import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initCartLineItemQty from '../components/cart-line-item-qty';
import initRelatedProducts from '../sections/product/related-products';

ready(() => {
  initCartLineItemQty();
  initRelatedProducts();
});

onShopifySectionLoad(() => {
  initRelatedProducts();
});
